function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke: #626a84;\r\n        stroke-linecap: round;\r\n        stroke-width: 1.3px;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke-linejoin: round;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_443",
  "data-name": "Group 443",
  transform: "translate(-7724.376 -6283.108)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_300",
  "data-name": "Path 300",
  className: "cls-1",
  d: "M7734.649,6283.758l-8.332,4.73,8.332,4.632",
  transform: "translate(-1.099 0)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_301",
  "data-name": "Path 301",
  className: "cls-2",
  d: "M7733.551,6316.1h-8.525",
  transform: "translate(0 -20.341)"
}));

var SvgLessEqual = function SvgLessEqual(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9.825 13.3",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLessEqual, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/less-equal.d002496f.svg";
export { ForwardRef as ReactComponent };